export const actionTypes = {
  REQUEST_START: 'TAPS.CARD_DOCUMENT_TYPES.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.CARD_DOCUMENT_TYPES.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.CARD_DOCUMENT_TYPES.REQUEST_FAILURE',
};

export function startRequest(cardTypeId) {
  return {
    type: actionTypes.REQUEST_START,
    payload: cardTypeId,
  };
}

export function requestSuccess(data, cardTypeId) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: { data, cardTypeId },
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
